import { useTranslation } from 'react-i18next';
import { SmartAction } from '@connect-x-app/shared-domain-models';
import { Row } from '@tanstack/react-table';

import { TableLayout } from '../../../../../../shared';
import { useSystemSmartActionTable } from '../../hooks/useSystemSmartActionTable';

import './SystemSmartActionsTable.scss';

type Props = {
  data: SmartAction[];
  onRowClicked: (row: Row<SmartAction>) => void;
};

export const SystemSmartActionsTable = ({ data, onRowClicked }: Props) => {
  const { t } = useTranslation();

  const table = useSystemSmartActionTable(data);

  return (
    <TableLayout
      className="table-wrapper--system-smart-actions"
      hasProportionalColumns
      isCollapsableTable
      onRowClicked={onRowClicked}
      rowClickAllowed
      table={table}
      titleText={t('SMART_ACTION.TABLES.SYSTEM_TITLE')}
      titleTooltip={t('SMART_ACTION.TABLES.SYSTEM_TOOLTIP')}
    />
  );
};
